import { render } from "./OfficeSet.vue?vue&type=template&id=2ff7e8eb"
import script from "./OfficeSet.vue?vue&type=script&lang=js"
export * from "./OfficeSet.vue?vue&type=script&lang=js"

import "./OfficeSet.vue?vue&type=style&index=0&id=2ff7e8eb&lang=scss"

import exportComponent from "/home/jb/dev/cambiatech/libreosteo/enterprise/libreosteoenterprise/loenterprise-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});qInstall(script, 'directives', {Ripple});
